<template>
  <v-app>
    <v-jumbotron>
      <v-container fill-height>
        <v-layout align-center>
          <v-flex text-xs-center>
            <v-flex pb-4>
              <h3 class="display-4 mb-4">404</h3>
              <span class="subtitle">Diese Seite konnte nicht gefunden werden.</span>
            </v-flex>
            <v-btn depressed color="primary" to="/">Zurück zur Startseite</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-jumbotron>
  </v-app>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>
